import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { withStyles, lighten, makeStyles } from "@material-ui/core/styles";
import customInputStyle from "assets/jss/material-dashboard-react/components/customInputStyle.js";
import FormControl from "@material-ui/core/FormControl";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Checkbox from "@material-ui/core/Checkbox";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import FilterListIcon from "@material-ui/icons/FilterList";
import Input from "@material-ui/core/Input";
import { Button } from "@material-ui/core";
import { getfaqlist, deletfaq } from "../../actions/users";
import { Link, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import ReactDatatable from "@ashvin27/react-datatable";
import moment from "moment";
import { toast } from "react-toastify";
import ReactHtmlParser from "react-html-parser";
function createData(name, calories, fat, carbs, protein) {
  return { name, calories, fat, carbs, protein };
}

const rows = [];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
toast.configure();
let toasterOption = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
// function getComparator(order, orderBy) {
//   return order === 'desc'
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) return order;
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }

const headCells = [
  { id: "question", numeric: false, disablePadding: true, label: "Question" },
  { id: "answer", numeric: true, disablePadding: false, label: "Answer" },
  { id: "Action", numeric: true, disablePadding: false, label: "Action" },
];

function EnhancedTableHead(props) {
  const {
    classes,
    onSelectAllClick,
    order,
    orderBy,
    numSelected,
    rowCount,
    onRequestSort,
  } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={"left"}
            // padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  highlight:
    theme.palette.type === "light"
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  title: {
    flex: "1 1 100%",
  },
}));

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
}));

const customStyle = makeStyles(customInputStyle);

export default function EnhancedTable() {
  const customStyles = customStyle();
  const classes = useStyles();
  const classesSearch = useToolbarStyles();
  const [order, setOrder] = React.useState("asc");
  const [orderBy, setOrderBy] = React.useState("calories");
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [userdet, setUser] = useState();
  const [userdet1, setUser1] = useState();

  const [typingTimeout, setTypingTimeout] = useState(0);
  const [searchQuery, setSearchQuery] = React.useState("");
  const [responsive, setresponsive] = useState(true);
  const history = useHistory();

  function editR(id, from) {
    console.log("sdvasdfv sdfvds", id, from);
    if (id != "") {
      // window.location="/KOLBNU/faqedit/"+id;
      history.push({
        pathname: "/PrivacyPolicyedit/" + id._id,
        state: {
          items: id,
          from: from,
        },
      });
    }
  }
  // const viewuser = (e) => {
  //     //console.lo(e.target.id);
  // }
  function deleteR(id, from) {
    if (id != "") {
      deletfaq(id, { dbname: "privacy", from: from });
      toast.success("Deleted successfully", toasterOption);
      getPrivacyList();
      //window.location="/faqlist";
    }
  }

  const getPrivacyList = async () => {
    var test = await getfaqlist({ dbname: "privacy" }); ////this func is same for faq,privacy,termsOfService,disclaimer
    console.log("dgfnjdfghmnf", test);

    setUser(
      test?.userValue?.length > 0 &&
        test?.userValue
          ?.map((ite) => (ite?.TopContent ? false : ite))
          .filter((ite) => ite && ite)
    );
    setUser1(
      test?.userValue?.length > 0 &&
        test?.userValue
          ?.map((ite) => (ite?.TopContent ? ite : false))
          .filter((ite) => ite && ite)
    );
  };
  const add = async (from) => {
    window.location = `/PrivacyPolicy/${from}`;
    console.log("sfhbndfgbhdfg", from);
    // history.push({
    //   pathname:`/KOLBNU/PrivacyPolicy/${from}`,
    //   state:{ from:from }
    // })
  };

  const handleChange1 = (event) => {
    const { name, value } = event.target;
    const self = this;
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    setSearchQuery(value);
    setTypingTimeout(
      setTimeout(function () {
        getAll({ search: value });
      }, 1000)
    );
  };

  const getAll = async (search = {}) => {
    let filterData = search;
    if (filterData.search == "") {
      filterData = {};
    }
    var res = await getfaqlist(filterData);
    console.lo("getfaqlist", res);
    setUser(res.userValue);
    setUser1(res.userValue.filter((ite) => console.log("ADfbsfdgbsdfgb", ite)));
  };

  useEffect(() => {
    //note:privacy,termsofservice,disclaimer file is clone of faq file in backend database will different plz don't mind function name and variable name in privacy,termsofservice,disclaimerfile
    getPrivacyList();
  }, []);
  const columns = [
    {
      key: "question",
      text: "Title",
      className: "question",
      align: "left",
      sortable: false,
    },
    {
      key: "answer",
      text: "Content",
      className: "answer",
      align: "left",
      sortable: false,
      cell: (record) => <>{ReactHtmlParser(record.answer)}</>,
    },
 
    {
      key: "date",
      text: "Date",
      className: "Date",
      align: "left",
      sortable: false,
      cell: (record) => (
        // //console.lo(record.date,"date")
        <div>
          <p>{moment(record.date).format("MMMM,Do YYYY, hh:mm A")}</p>
        </div>
      ),
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 200,
      align: "left",
      sortable: false,
      cell: (record) => {
        //console.lo(record, 'recordssssss');
        const checkin = record.status;
        //console.lo(checkin, 'checkineeed');
        if (checkin == "0") {
          var lockVal = "fa fa-lock";
        } else {
          var lockVal = "fa fa-unlock";
        }

        return (
          <Fragment>
            <button
              data-toggle="modal"
              data-target="#update-template-modal"
              className="btn btn-primary btn-sm"
              onClick={() => editR(record, "QA")}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              className="btn btn-danger btn-sm mr-1"
              onClick={() => deleteR(record._id, "QA")}
            >
              <i className="fa fa-trash"></i>
            </button>
            {/*  <button 
                               className="btn btn-primary btn-sm mr-1"
                               onClick={()=>activeStatus(record.status,record.id)}>
                                <i className={lockVal}></i>
                            </button>*/}
          </Fragment>
        );
      },
    },
  ];

  const columns1 = [
    {
      key: "TopContent",
      text: "Top Content",
      className: "TopContent",
      align: "left",
      sortable: false,
      cell: (record) => <>{ReactHtmlParser(record?.TopContent)}</>,
    },

    {
      key: "date",
      text: "Date",
      className: "Date",
      align: "left",
      sortable: false,
      cell: (record) => (
        // //console.lo(record.date,"date")
        <div>
          <p>{moment(record.date).format("MMMM,Do YYYY, hh:mm A")}</p>
        </div>
      ),
    },

    {
      key: "action",
      text: "Action",
      className: "action",
      width: 200,
      align: "left",
      sortable: false,
      cell: (record) => {
        //console.lo(record, 'recordssssss');
        const checkin = record.status;
        //console.lo(checkin, 'checkineeed');
        if (checkin == "0") {
          var lockVal = "fa fa-lock";
        } else {
          var lockVal = "fa fa-unlock";
        }

        return (
          <Fragment>
            <button
              data-toggle="modal"
              data-target="#update-template-modal"
              className="btn btn-primary btn-sm"
              onClick={() => editR(record, "top")}
              style={{ marginRight: "5px" }}
            >
              <i className="fa fa-edit"></i>
            </button>
            <button
              className="btn btn-danger btn-sm mr-1"
              onClick={() => deleteR(record._id, "top")}
            >
              <i className="fa fa-trash"></i>
            </button>
            {/*  <button 
                             className="btn btn-primary btn-sm mr-1"
                             onClick={()=>activeStatus(record.status,record.id)}>
                              <i className={lockVal}></i>
                          </button>*/}
          </Fragment>
        );
      },
    },
  ];

  const configdata = {
    page_size: 10,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: <i class="fa-solid fa-angles-left" />,
        previous: <i class="fa-solid fa-angle-left" />,
        next: <i class="fa-solid fa-chevron-right" />,
        last: <i class="fa-solid fa-angles-right" />,
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: false,
    defaultSortAsc: true,
  };

  // useEffect(() => {
  //   console.log("useeffectcalled");
  //   window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  // }, []);

  const pageChange = (pageData) => {
    document
      .getElementsByClassName("makeStyles-mainPanel-2")[0]
      .scrollTo(0, 0);
  };
  const pageChangee = (pageData) => {
    document
      .getElementsByClassName("makeStyles-mainPanel-2")[0]
      .scrollTo(0, 0);
  };

  const onChangeFun = () => {
    console.log("onchange funn");
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  return (
    <div className={classes.root}>
      {console.log("sdfbsfgbdsfg", userdet1)}
      <div className="page_header">
        <h2>Privacy Policy List</h2>
        <div>
          {/* <Select
                    labelId="demo-simple-select-helper-label"
                    id="demo-simple-select-helper"
                    value={choose}
                    onChange={handleChange}>
                        <MenuItem value={"Daily"}>Daily</MenuItem>
                        <MenuItem value={"Monthly"}>Monthly</MenuItem>
                        <MenuItem value={"Custom"}>Custom</MenuItem>
                    </Select>
                    <CSVLink data={csvData} > <button
                       className="ml-3" variant="contained" color="primary"
                    >
                     Download
                    </button>
                    </CSVLink> */}
          {/* <Button className="ml-3" variant="contained" color="primary" onClick={download}>Download</Button> */}
          {console.log("dfgndfhndfgnfghn", userdet1)}
          {userdet1?.length > 0 ? (
            ""
          ) : (
            <Button
              className="Button cmn_btn_pd"
              variant="contained"
              color="primary"
              onClick={() => add("top")}
            >
              Add
            </Button>
          )}
        </div>
      </div>
      <Paper className={classes.paper + " paper_padding"}>
        <ReactDatatable
          responsive={responsive}
          config={configdata}
          records={userdet1}
          columns={columns1}
          onPageChange={pageChange}
        />
      </Paper>
      <Button
        className="Button cmn_btn_pd mb-3"
        variant="contained"
        color="primary"
        onClick={() => add("QA")}
      >
        Add
      </Button>

      <Paper className={classes.paper + " paper_padding"}>
        <ReactDatatable
          responsive={responsive}
          config={configdata}
          records={userdet}
          columns={columns}
          onPageChange={pageChangee}
        />
      </Paper>
      {/*  <FormControlLabel
        control={<Switch checked={dense} onChange={handleChangeDense} />}
        label="Dense padding"
      />*/}
    </div>
  );
}
